// extracted by mini-css-extract-plugin
export var boldText = "SwapConfirmation_boldText__P3uaD";
export var bullet = "SwapConfirmation_bullet__0NKoR";
export var bulletPoints = "SwapConfirmation_bulletPoints__3+gKd";
export var confirm = "SwapConfirmation_confirm__atkfC";
export var faq = "SwapConfirmation_faq__CQzEH";
export var md = "768px";
export var navigation = "SwapConfirmation_navigation__V3b2I";
export var neverMind = "SwapConfirmation_neverMind__APIkh";
export var shared = "'../../../shared.module.css'";
export var swapConfirmation = "SwapConfirmation_swapConfirmation__6EFPx";
export var terms = "SwapConfirmation_terms__X2zm8";
export var title = "SwapConfirmation_title__9yU+A";